import { jwtDecode } from "jwt-decode";
import { environment } from "../../../environments/environment";
import { getWindow } from "../browser/window.utilities";

export function validateTokenAndDecode(token: string): any {

    const decodedToken = jwtDecode(token);
    
    if (isTokenValid(decodedToken) || (decodedToken as any).token_use === 'id') {
        console.log('Token is valid and user is authenticated.');
        return decodedToken;
    } else {
        console.error('Token is invalid or expired.');
        return null;
    }
} 

function isTokenValid(decodedToken: any) {
    const currentTime = Math.floor(Date.now() / 1000);
    return decodedToken && decodedToken.exp > currentTime && decodedToken.client_id === environment.cognito.ClientId;
}

export function extractTokensFromUrl(): { idToken: string | null; accessToken: string | null } {
    const windowObj = getWindow();
    const location = windowObj ? windowObj.location : null;
    const hash = location ? location.hash : '';
    const urlParams = new URLSearchParams(hash ? hash.substring(1) : '');
    return {
      idToken: urlParams.get('id_token'),
      accessToken: urlParams.get('access_token')
    };
  }

